import React, { useState } from 'react'

//* import MUI
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

//* import sub component
import Button from '../../Subcomponents/Button';

//* import Images
// import crossImage from "../../assets/images/cross.svg";
// import MessageIcon from "../../assets/images/MessageIcon.svg"

//* import Css
import cssClasses from "./FieldEntriesModal.module.css";

//* import npm
import { List, ListItem, Tooltip, Typography } from '@mui/material';
// import { dataGridStyles } from '../../DefaultsValues/GlobalStyles';
import { DataGrid } from '@mui/x-data-grid';
import Close from '../../Components/Icons/Close';


const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    // padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  '& .MuiDataGrid-cell': {
    padding: '0 1.5rem !important',
    fontFamily: 'Roboto-Regular',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: '2rem',
    letterSpacing: '0.2px',
    color: '#3C4043',
    minHeight: '53px !important',
    outline: 'none !important',
    cursor: 'pointer',
    width: '100%',
    whiteSpace: 'break-spaces !important'
  },
  '& .MuiDataGrid-row': {
    minHeight: '53px !important'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    padding: '1.5rem',
  },
  '& .MuiDataGrid-cellContent': {
    padding: '1.5rem',
    width: '100%',
    whiteSpace: 'break-spaces !important',
    textOverflow: 'unset !important'
  },
};

function FieldEntriesModal({ open, handleClose, fieldEntriesArray, DatabaseTotal }) {
  const [FailedCount, setFailedCount] = useState(0);

  console.log("fieldEntriesArray", fieldEntriesArray.length)
  console.log("DatabaseTotal", DatabaseTotal)
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)"
          }
        }
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <h1>Failed Records({fieldEntriesArray.length}/{DatabaseTotal})</h1>
          <Box
            ml={'auto'}
            mt={1}
            onClick={handleClose}
            style={{ cursor: 'pointer' }}
          >
            <Close width={'1.2rem'} height={'1.2rem'} />
          </Box>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
        </div>

        <div className={cssClasses.mainContainer} style={{ minHeight: '60rem', display: 'flex', flexDirection: 'column' }}>

          <DataGrid
            rows={fieldEntriesArray}
            columns={failedEntriesColumns}
            hideFooterPagination={false}
            hideFooter={false}
            pageSize={10}
            rowsPerPageOptions={[10]}
            // page={pageMaintain}
            sx={[dataGridStyles]}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            disableDensitySelector
            disableSelectionOnClick
            disableVirtualization
          // loading={dataGridLoading}
          // onPageChange={(_page)=>{
          //   console.log({_page});
          //   setPageMaintain(_page)
          //   if (pageNumber < _page) {
          //     // * Next When Data need
          //     setPageNumber(_page);
          //     getMoreData()
          //   }else{
          //     // *previous
          //   }
          // }}
          />

        </div>

        <div className={cssClasses.footer}>
          <div><Button style={{ color: "#344054", backgroundColor: "#ffffff", border: "1px solid #E5E7EB" }} btnName={"Close"} clicked={handleClose} /></div>
        </div>
      </Box>
    </Modal>
  )
}

export default FieldEntriesModal;

const failedEntriesColumns = [
  // { field: "id", headerName: "Sr.no", width: 100, sortable: false },
  {
    field: 'Wing', headerName: 'Wing', width: 150, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.Wing}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  {
    field: 'unitNo', headerName: 'unitNo', width: 200, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.unitNo}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  {
    field: 'Area', headerName: 'Area', width: 150, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.Area}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  {
    field: 'BSP', headerName: 'Agreement Value', width: 150, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.BSP}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  // { field: 'OCR', headerName: 'OCR', width: 150 , sortable: false,
  // renderCell: (params) => {
  //   return (
  //     <Box display={"flex"} flexDirection={"column"}>
  //       <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.OCR}</Typography>
  //       {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
  //     </Box>
  //   )
  // }
  // },
  {
    field: 'GST', headerName: 'GST', width: 150, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.GST}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  {
    field: 'SDR', headerName: 'SDR', width: 150, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.SDR}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  // {
  //   field: 'Registration', headerName: 'Registration', width: 200, sortable: false,
  //   renderCell: (params) => {
  //     return (
  //       <Box display={"flex"} flexDirection={"column"}>
  //         <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.Registration}</Typography>
  //         {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
  //       </Box>
  //     )
  //   }
  // },
  {
    field: 'totalCost', headerName: 'totalCost', width: 200, sortable: false,
    renderCell: (params) => {
      return (
        <Box display={"flex"} flexDirection={"column"}>
          <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.TotalCost}</Typography>
          {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
        </Box>
      )
    }
  },
  {
    field: 'reason', headerName: 'Reason', width: 400, sortable: false,
    renderCell: (params) => {
      console.log(Object.keys(params.row[params.field]).filter(f => params.row[params.field][f].length).length);

      console.log(params.value);
      return (<>
        <Tooltip
          followCursor
          arrow
          title={
            <List style={{ fontSize: "1.4rem", textTransform: 'capitalize' }}>
              {
                params.value.split(",")?.map((m, index) => (
                  <ListItem key={`listItem_${m}_${index + 1}`} disablePadding>{m}</ListItem>
                ))
              }
            </List>
          }
        >
          <Typography fontSize={"1.4rem"}>{params.value}</Typography>
        </Tooltip>
      </>)
    }
  },
]

// const failedPhotosColumns = [
//   // { field: "id", headerName: "Sr.no", width: 100, sortable: false },
//   { field: 'ppo_number', headerName: 'PPO Number', width: 150 , sortable: false,
//     renderCell: (params) => {
//       return (
//         <Box display={"flex"} flexDirection={"column"}>
//           <Typography color={"#101828"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={500}>{params.row.ppo_number}</Typography>
//           {/* <Typography color={"#667085"} fontSize={"1.4rem"} lineHeight={"2rem"} fontWeight={400}>{params.row.date}</Typography> */}
//         </Box>
//       )
//     }
//   },
//   { field: 'file', headerName: 'photo', width: 300 , sortable: false,
//     renderCell: (params) => {
//       return (
//         <Box display={"flex"} flexDirection={"row"} alignItems={"center"} height={"100%"}>
//           <img src={URL.createObjectURL(params.value)} alt="" style={{height: "100%"}}/>
//         </Box>
//       )
//     }
//   },
//   { field: 'reason', headerName: 'Reason', width: 400 , sortable: false,
//     renderCell: (params) => {
//       // console.log(Object.keys(params.row[params.field]).filter(f=>params.row[params.field][f].length).length);
//       // console.log(params.value);
//       return (<>
//         <Tooltip
//           followCursor
//           arrow
//           title={
//             <List style={{fontSize: "1.4rem", textTransform: 'capitalize'}}>
//               {
//                 params.value.split(",")?.map((m,index)=>(
//                   <ListItem key={`listItem_${m}_${index+1}`} disablePadding>{m}</ListItem>
//                 ))
//               }
//             </List>
//           }
//         >
//           <Typography fontSize={"1.4rem"}>{params.value}</Typography>
//         </Tooltip>
//       </>)
//     }
//   },
// ]